export default __webpack_public_path__ + "static/media/mentee.89e151fd.jpg";